module.exports = __webpack_public_path__ + "static/media/4_Materiali OSA 25_09_2015.bb6dc166.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/4_Materiali OSA 25_09_2015.pdf
// module id = 180
// module chunks = 0